import { Question } from "@phosphor-icons/react";
import UserProfile from "./UserProfile";

const BottomNavItems = ({
  sidenavCollapsed,
  onSupportClick,
  onChangeSidenavCollapse,
  docPanelOpen,
}) => {
  return (
    <div className="flex flex-col gap-[12px]">
      <div
        data-testid="nav-contact-help"
        className="flex items-center gap-[8px] pl-[8px] pr-[8px] py-[12px] cursor-pointer"
        onClick={onSupportClick}
      >
        <Question size={16} className="text-[#525252]" />
        {!sidenavCollapsed && (
          <p className="font-['DM_Sans'] font-medium text-[12px] leading-[100%] tracking-[0px] text-[#525252]">
            Live Support
          </p>
        )}
      </div>

      <div className="border-t border-[#E5E5E5]" />

      <div data-testid="nav-user-profile" className="cursor-pointer">
        <UserProfile />
      </div>
    </div>
  );
};

export default BottomNavItems;
